import { useTheme } from '../../../components/ThemeProvider';
import { useHoSoToChuc } from './useHoSoToChuc';

export interface NhanDien {
  /** Tên hiển thị của tổ chức; `null` khi chưa tải hoặc không có tổ chức (cổng nền tảng). */
  ten: string | null;
  tenVietTat: string | null;
  /**
   * Logo hợp với chủ đề đang bật: nền tối thì dùng logo nền tối, thiếu thì lùi
   * về logo nền sáng. `null` là tổ chức chưa tải logo, dùng logo Native.
   */
  logoUrl: string | null;
  faviconUrl: string | null;
}

/**
 * Nhận diện của tổ chức để áp lên giao diện (ADR-UI-0016 mục 4). Mọi chỗ cần
 * logo hay tên đọc qua hook này, không tự gọi API.
 *
 * Đang tải hay lỗi thì trả toàn `null`: giao diện rơi về logo Native thay vì
 * chặn cả màn chỉ vì không lấy được logo.
 */
export function useNhanDien(): NhanDien {
  const { theme } = useTheme();
  const { data } = useHoSoToChuc();
  if (!data) return { ten: null, tenVietTat: null, logoUrl: null, faviconUrl: null };
  const logoUrl =
    theme === 'dark' ? (data.logo_dark_url ?? data.logo_light_url) : data.logo_light_url;
  return {
    ten: data.display_name,
    tenVietTat: data.short_name,
    logoUrl,
    faviconUrl: data.favicon_url,
  };
}
